// extracted by mini-css-extract-plugin
export default {"container":"Tab_container__DOEi2","active":"Tab_active__4mKHs","required":"Tab_required__HayT2"};